// src/components/products/Products.jsx
import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import Ratings from '../Ratings';

// Helper: compute average rating from rating_review only
const getAverageRating = (product) => {
  if (!product || !product.rating_review || product.rating_review.length === 0) return 0;
  let totalCount = 0;
  let totalSum = 0;
  for (let i = 0; i < product.rating_review.length; i++) {
    const count = product.rating_review[i]?.sum || 0;
    const ratingVal = 5 - i;
    totalCount += count;
    totalSum += ratingVal * count;
  }
  if (totalCount === 0) return 0;
  return (totalSum / totalCount).toFixed(1);
};

const Products = ({ title, products }) => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  const ButtonGroup = ({ next, previous }) => {
    return (
      <div className="flex justify-between items-center">
        <div className="text-lg font-bold text-slate-600">{title}</div>
        <div className="flex justify-center items-center gap-3 text-slate-600">
          <button
            onClick={() => previous()}
            className="w-[30px] h-[30px] flex justify-center items-center bg-slate-300 border border-slate-200"
          >
            <FiChevronLeft />
          </button>
          <button
            onClick={() => next()}
            className="w-[30px] h-[30px] flex justify-center items-center bg-slate-300 border border-slate-200"
          >
            <FiChevronRight />
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="flex gap-8 flex-col-reverse">
      <Carousel
        autoPlay={false}
        infinite={false}
        arrows={false}
        responsive={responsive}
        transitionDuration={500}
        renderButtonGroupOutside={true}
        customButtonGroup={<ButtonGroup />}
      >
        {products.map((group, i) => (
          <div key={i} className="flex flex-col justify-start gap-2">
            {group.map((pl, j) => {
              const averageRating = getAverageRating(pl);
              return (
                <Link key={j} className="flex justify-start items-start" to={`/product/details/${pl.slug}`}>
                  <img className="w-[80px] h-[80px]" src={pl.images[0]} alt="product" />
                  <div className="px-3 flex flex-col justify-start items-start gap-1 text-slate-600">
                    <h2 className="text-[13px]">{pl.name?.slice(0, 40)}</h2>
                    {/* Added snippet: Display shopName if available */}
                    {pl.shopName && (
                      <p className="text-xs text-gray-500">by {pl.shopName}</p>
                    )}
                    <span className="text-md font-bold">₹{pl.price}</span>
                    <div className="flex items-center">
                      <Ratings ratings={parseFloat(averageRating)} />
                      <span className="ml-2 text-sm text-green-600">
                        ({pl.totalReview || 0} reviews)
                      </span>
                    </div>
                    <p className="text-[13px]">{pl.description?.slice(0, 50)}...</p>
                  </div>
                </Link>
              );
            })}
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default Products;
